var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(!_vm.loading && _vm.issuesCount.length)?_c('div',[_c('apexcharts',{attrs:{"options":_vm.issuesOptions,"series":_vm.issuesCount}})],1):(!_vm.loading)?_c('div',[_c('p',[_vm._v("No data available")])]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }